export const frontmatter = {
    "draft": true,
    "title": "API Integration",
    "description": "Connect external systems with OnnIA using the API integration.",
    "sidebar_label": "API",
    "sidebar_group": "guides",
    "sidebar_order": 3
}

export const toc = []